var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageFilterOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98271 15.7991C11.0432 15.7551 12.7 14.071 12.7 12C12.7 9.92897 11.0432 8.24489 8.9827 8.20089C8.29639 9.30363 7.89996 10.6055 7.89996 12C7.89996 13.3945 8.2964 14.6964 8.98271 15.7991Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9 4.59998C4.81309 4.59998 1.5 7.91307 1.5 12C1.5 16.0869 4.81309 19.4 8.9 19.4C10.0069 19.4 11.0571 19.1569 12 18.7213C12.9429 19.1569 13.9931 19.4 15.1 19.4C19.1869 19.4 22.5 16.0869 22.5 12C22.5 7.91307 19.1869 4.59998 15.1 4.59998C13.9931 4.59998 12.9429 4.84301 12 5.27863C11.0571 4.84301 10.0069 4.59998 8.9 4.59998ZM3.3 12C3.3 8.90718 5.80721 6.39998 8.9 6.39998C11.9928 6.39998 14.5 8.90718 14.5 12C14.5 15.0928 11.9928 17.6 8.9 17.6C5.80721 17.6 3.3 15.0928 3.3 12ZM13.8861 6.5319C15.3693 7.88519 16.3 9.8339 16.3 12C16.3 14.1661 15.3693 16.1148 13.8861 17.4681C14.2769 17.5544 14.6831 17.6 15.1 17.6C18.1928 17.6 20.7 15.0928 20.7 12C20.7 8.90718 18.1928 6.39998 15.1 6.39998C14.6831 6.39998 14.2769 6.44552 13.8861 6.5319Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFilterOutline);
export default __webpack_public_path__ + "static/media/image_filter_outline.be19729929ce7fee83bc9a3a1aadeef0.svg";
export { ForwardRef as ReactComponent };